var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.512,
    height: 49,
    viewBox: "0 0 51.512 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52038",
    d: "M248.561,413.942h4.124v7.216h-4.124Z",
    transform: "translate(-245.468 -372.158)",
    fill: "#ff7d73",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30982",
    d: "M295.8,381.942s-1.419.02-2.91.029c-.746,0-1.509.007-2.118,0s-1.2-.037-1.092-.024a1.191,1.191,0,0,0-.927.282,1.386,1.386,0,0,0-.47.908,1.435,1.435,0,0,0,.261,1,1.237,1.237,0,0,0,.841.507,11.485,11.485,0,0,0,1.372.04c.54,0,1.19,0,1.84,0l-15.4,15.524L272.99,393.4a1.2,1.2,0,0,0-1.86-.281L246,416.18a1.433,1.433,0,0,0-.142,1.913,1.193,1.193,0,0,0,1.772.154l24.05-22.073,4.243,6.87a1.2,1.2,0,0,0,1.9.238l16.733-16.862v3.662a1.26,1.26,0,1,0,2.513,0V383.3a1.412,1.412,0,0,0-.373-.965A1.21,1.21,0,0,0,295.8,381.942Z",
    transform: "translate(-245.56 -381.941)",
    fill: "#24bc94",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54017",
    d: "M256.556,408.942h4.124v12.37h-4.124Z",
    transform: "translate(-242.473 -372.312)",
    fill: "#ffa95d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54021",
    d: "M264.556,404.053h4.123v17.41h-4.123v-17.41Z",
    transform: "translate(-240.227 -372.463)",
    fill: "#87d97a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54025",
    d: "M272.556,400.942h4.123v20.617h-4.123Z",
    transform: "translate(-237.981 -372.56)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54029",
    d: "M280.556,394.942h4.123v26.8h-4.123Z",
    transform: "translate(-235.234 -372.745)",
    fill: "#e7e7e7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/layer1.0e89425897edab752912f8e5c2952372.svg";
export { ForwardRef as ReactComponent };